import Vue from 'vue'
import Vuex from 'vuex'
import { reqParams } from '@/api/params'
import { userinfo, personOne, companyOne } from '@/api/user'

const re = /^[0-9]+.?[0-9]*/
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    cheating: localStorage.getItem('cheating') ? JSON.parse(localStorage.getItem('cheating')) : false,
    cheatingPhone: localStorage.getItem('cheatingPhone') ? JSON.parse(localStorage.getItem('cheatingPhone')) : false,
    personData: localStorage.getItem('personData') ? JSON.parse(localStorage.getItem('personData')) : '',
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '', // 清除数据
    commonParams: '', // 公共参数
    recognizedStatus: localStorage.getItem('recognizedStatus') ? JSON.parse(localStorage.getItem('recognizedStatus')) : '',
    companyType: localStorage.getItem('companyType') ?? ''
  },
  getters: {
    commonParams: (state) => {
      // data的取值:YEAR_SECLET_GROUP(年份), MARRIAGE_STATUS(婚姻状态)，POLITICE_FACE(政治面貌)VALID_CERTIFICATE(有效证件类型),
      // PROFESSIONAL_SKILLS(最高专业技术任职资格),INDUSTRY_TYPE(行业类型), EDUCATION_TYPE(学历), DEGREE_TYPE(学位)，HOUST_TYPE(意向户型)，SEX_TYPE(性别类型)
      // key的取值:configKey  不传返回该项对象完整数据,传key,返回具体name
      // console.log(state, 'state')
      const commonParams = JSON.parse(sessionStorage.getItem('setParams'))
      // commonParams.TALENT_FUND_TYPE = [
      //   {
      //     configValue: '首批',
      //     configKey: 'first'
      //   },
      //   {
      //     configValue: '后续',
      //     configKey: 'follow'
      //   }
      // ]
      return function (data, key = '') {
        const key_ = key ? key.toString() : ''
        if (!data && !key_) {
          return commonParams
        }
        if (key_ || re.test(key)) {
          const result = commonParams[data].find((item) => {
            // eslint-disable-next-line eqeqeq
            return item.configKey == key_
          })
          return result ? result.configValue : ''
          // return commonParams[data].find((item) => {
          //   return item.configKey === key_
          // }).configValue
        }
        return commonParams[data]
      }
    }
  },
  mutations: {
    updateCheating(state, cheating) {
      window.localStorage.setItem('cheating', JSON.stringify(cheating))
      state.cheating = cheating
    },
    setPersonData(state, personData) {
      window.localStorage.setItem('personData', JSON.stringify(personData))
      state.personData = personData
    },
    setUserInfo(state, userInfo) {
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
      state.userInfo = userInfo
    },
    removeUserInfo(state) {
      state.userInfo = ''
      state.recognizedStatus = ''
      state.personData = ''
      window.localStorage.removeItem('access-token') // 清除数据
      window.localStorage.removeItem('userInfo') // 清除数据
      window.localStorage.removeItem('personData') // 清除数据
      window.localStorage.removeItem('recognizedStatus') // 清除数据
    },
    // 公共参数
    setParams(state, commonParams) {
      state.commonParams = commonParams
      // console.log(state.commonParams, 'commonParams设置')
    },
    setRecognizedStatus(state, recognizedStatus) {
      window.localStorage.setItem('recognizedStatus', JSON.stringify(recognizedStatus))
      state.recognizedStatus = recognizedStatus
    }
  },
  actions: {
    // 获取公共参数
    getParams(state) {
      console.log(state, 'state')
      // if (localStorage.getItem('access-token')) {
      reqParams().then((res) => {
        if (res.code === 200) {
          state.commit('setParams', res.data)
          console.log('res.data :>> ', res.data)
          sessionStorage.setItem('setParams', JSON.stringify(res.data))
        }
      })
      // }
    },
    upUserinfo(state) {
      if (localStorage.getItem('access-token')) {
        userinfo().then((res) => {
          state.commit('setUserInfo', res.data)
        })
      }
    },
    async upPersonData(state) {
      // let res
      if (state.state.userInfo.userType === 1) {
        personOne().then((res) => {
          state.commit('setPersonData', res.data)
        })
        // res = await personOne()
      } else {
        companyOne({
          companyId: state.state.userInfo.companyId
        }).then((res) => {
          state.commit('setPersonData', res.data)
        })
        // res = await companyOne({
        //   companyId: state.state.userInfo.companyId
        // })
      }
      // state.commit('setPersonData', res.data)
    }
  }
})

export default store
